// extracted by mini-css-extract-plugin
module.exports = {"App":"global_App__3Sk0w","infiniteRotate":"global_infiniteRotate__1sHyv","headericon":"global_headericon__Pw9RE"};